module.exports = require('../../es/object/assign');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/object/assign.js
// module id = 242
// module chunks = 1